import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "../layout/Layout";
import Home from "../pages/Home";
import ProjectDetail from "../pages/ProjectDetail";
import ProtectedRoute from "../components/ProtectedDevelopersRoute";
import Developers from "../pages/Developers";
import DeveloperDetail from "../pages/DeveloperDetail";
import Projects from "../pages/Projects";

const AppRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/project/:id" element={<ProjectDetail />} />

            {/* Section deep-link routes — render Home and auto-scroll to section */}
            <Route path="/portfolio" element={<Home scrollTo="portfolio" />} />
            <Route path="/services" element={<Home scrollTo="services" />} />
            <Route path="/about_us" element={<Home scrollTo="about" />} />
            <Route path="/contact" element={<Home scrollTo="contact" />} />

            {/* Developers List — no protection */}
            <Route path="/engineers" element={<Developers />} />

            {/* Developer Detail — protected */}
            <Route
                path="/engineer/:id"
                element={
                    <ProtectedRoute>
                        <DeveloperDetail />
                    </ProtectedRoute>
                }
            />
        </Route>
    </Routes>
  );
};

export default AppRoutes;
